import {BaseEntityConfig, WhiteListFields} from '~/redux/base-entity-config';
import {SchoolEntity} from '~/redux/schools/types';

class EntityConfig extends BaseEntityConfig<SchoolEntity> {
  entityKey = 'schools';

  associates = [];

  whiteListFields: WhiteListFields<SchoolEntity> = ['*'];

  getAccessors = (value: SchoolEntity) => {
    //
  };
}

const schoolEntConf = new EntityConfig();

export const schoolSchema = schoolEntConf.getEntitySchema();

export default schoolEntConf;

export const SOURCES_SCHOOL = {
  SCHOOLS_PAGE: 'SCHOOLS_PAGE',
  SCHOOLS_DROPDOWN: 'SCHOOLS_DROPDOWN',
};
